export const loadingAnimation = {
  v: '5.7.12',
  fr: 60,
  ip: 70,
  op: 190,
  w: 400,
  h: 400,
  nm: 'Comp 1',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'Ellipse 1',
    parent: 3,
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 1,
        k: [{
          i: { x: 0.823, y: 0.511 },
          o: { x: 0.537, y: 0 },
          t: 70,
          s: [16.156, -68, 0],
          to: [36.344, 1.291, 0],
          ti: [-68.694, -2.358, 0],
        }, {
          i: { x: 0.222, y: 1 },
          o: { x: 0.346, y: 0.406 },
          t: 100,
          s: [207.981, -62.411, 0],
          to: [153.031, 5.252, 0],
          ti: [-176.864, -6.835, 0],
        }, {
          i: { x: 0.935, y: 0.933 },
          o: { x: 0.777, y: 0 },
          t: 134,
          s: [720, -43, 0],
          to: [-216.65, -322.779, 0],
          ti: [151.61, -185.223, 0],
        }, {
          i: { x: 0.193, y: 0.524 },
          o: { x: 0, y: 0 },
          t: 165,
          s: [134.243, -62.309, 0],
          to: [-7.512, -20.5, 0],
          ti: [23.53, 5.825, 0],
        }, {
          i: { x: 0.752, y: 0.684 },
          o: { x: 0.518, y: 0.414 },
          t: 169,
          s: [98.502, -101.522, 0],
          to: [-21.028, -5.206, 0],
          ti: [0, 0, 0],
        }, {
          i: { x: 0.833, y: 1 },
          o: { x: 0.166, y: 1 },
          t: 175,
          s: [49.156, -68, 0],
          to: [0, 0, 0],
          ti: [5.5, 0, 0],
        }, {
          t: 190,
          s: [16.156, -68, 0],
        }],
        ix: 2,
        l: 2,
      },
      a: {
        a: 0, k: [720, -43, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [100, 100, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 1,
          k: [{
            i: { x: [0.4, 0.4], y: [1, 1] },
            o: { x: [0.81, 0.81], y: [0, 0] },
            t: 70,
            s: [128, 128],
          }, {
            i: { x: [0.19, 0.19], y: [1, 1] }, o: { x: [0.6, 0.6], y: [0, 0] }, t: 130, s: [86, 86],
          }, { t: 190, s: [128, 128] }],
          ix: 2,
        },
        p: { a: 0, k: [0, 0], ix: 3 },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false,
      }, {
        ty: 'st',
        c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
        o: { a: 0, k: 100, ix: 4 },
        w: {
          a: 1,
          k: [{
            i: { x: [0.4], y: [1] }, o: { x: [0.81], y: [0] }, t: 70, s: [16],
          }, {
            i: { x: [0.19], y: [1] }, o: { x: [0.6], y: [0] }, t: 130, s: [4],
          }, { t: 190, s: [16] }],
          ix: 5,
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false,
      }, {
        ty: 'fl', c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
      }, {
        ty: 'tr', p: { a: 0, k: [720, -43], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false,
    }],
    ip: 0,
    op: 264,
    st: 0,
    bm: 0,
  }, {
    ddd: 0,
    ind: 2,
    ty: 3,
    nm: 'Null 1',
    sr: 1,
    ks: {
      o: { a: 0, k: 0, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [179.5, 241, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [50, 50, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [40, 40, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    ip: 0,
    op: 264,
    st: 0,
    bm: 0,
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: 'Shape Layer 2',
    parent: 2,
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: {
        a: 1,
        k: [{
          i: { x: [0.4], y: [1] }, o: { x: [0.81], y: [0] }, t: 60, s: [-25],
        }, {
          i: { x: [0.19], y: [1] }, o: { x: [0.6], y: [0] }, t: 120, s: [13.5],
        }, { t: 180, s: [-25] }],
        ix: 10,
        x: 'var $bm_rt;\n$bm_rt = loopOut();',
      },
      p: {
        a: 0, k: [-3.5, 122, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [253, 0, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [100, 100, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0]], o: [[0, 0], [0, 0]], v: [[-398, 122], [402, 122]], c: false,
          },
          ix: 2,
          x: 'var $bm_rt;\n$bm_rt = createPath([\n    [\n        0,\n        0\n    ],\n    [\n        720,\n        0\n    ]\n]);',
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 16, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
      }, {
        ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
      }],
      nm: 'Shape 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false,
    }],
    ip: 0,
    op: 264,
    st: 0,
    bm: 0,
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: 'Shape Layer 1',
    parent: 2,
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: {
        a: 1,
        k: [{
          i: { x: [0.342], y: [0.644] }, o: { x: [0.827], y: [0.447] }, t: 0, s: [0],
        }, { t: 60, s: [360] }],
        ix: 10,
        x: 'var $bm_rt;\n$bm_rt = loopOut();',
      },
      p: {
        a: 0, k: [103.5, -22, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [0, 0, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [100, 100, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 1,
          k: [{
            i: { x: [0.909, 0.912], y: [1, 1] },
            o: { x: [0.69, 0.69], y: [0, 0] },
            t: 0,
            s: [256, 512],
          }, {
            i: { x: [0.31, 0.31], y: [1, 1] },
            o: { x: [0.118, 0.118], y: [0, 0] },
            t: 35,
            s: [220, 650],
          }, { t: 60, s: [256, 512] }],
          ix: 2,
          x: 'var $bm_rt;\n$bm_rt = loopOut();',
        },
        p: { a: 0, k: [0, 0], ix: 3 },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false,
      }, {
        ty: 'st',
        c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
        o: { a: 0, k: 100, ix: 4 },
        w: {
          a: 1,
          k: [{
            i: { x: [0.909], y: [1] }, o: { x: [0.69], y: [0] }, t: 0, s: [16],
          }, {
            i: { x: [0.31], y: [1] }, o: { x: [0.118], y: [0] }, t: 35, s: [4],
          }, { t: 60, s: [16] }],
          ix: 5,
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false,
      }, {
        ty: 'tr', p: { a: 0, k: [0, 0], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false,
    }],
    ip: 0,
    op: 252,
    st: 0,
    bm: 0,
  }],
  markers: [],
};
